class WorkItemTransitionModel {
  constructor(transition) {
    this.id = transition.transitionId || null;
    this.fromStageType = transition.fromStageType || null;
    this.processOrder = transition.processOrder || null;
    this.transitionedBy = transition.transitionedBy?.displayName || null;
    this.toStageType = transition.toStageType || null;
    this.transitionedAt = transition.transitionedAt || null;
    this.note = transition.note || transition.notes || null;
  }
}

export default WorkItemTransitionModel;
